import { Link } from 'react-router-dom';
import { useCallback } from 'react';

export default function HeroSection() {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20coral%20and%20cream%20tones%2C%20minimalist%20modern%20design%20with%20smooth%20curves%2C%20ethereal%20atmosphere%2C%20clean%20aesthetic%2C%20no%20text%2C%20no%20sharp%20edges%2C%20dreamy%20soft%20focus&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-6">
            免费在线成网站
            <br />
            <span className="text-primary-300">零门槛快速建站</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            无需编程知识，拖拽式可视化编辑器，海量精美模板任意选择。几分钟即可完成网站搭建，支持自定义域名、移动端适配，帮助个人、企业、创业者快速拥有专属网站。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              onClick={scrollToTop}
              className="w-full sm:w-auto px-8 py-3.5 text-base font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即免费建站
            </Link>
            <Link
              to="/articles"
              onClick={scrollToTop}
              className="w-full sm:w-auto px-8 py-3.5 text-base font-medium rounded-md bg-background-50/15 text-background-50 hover:bg-background-50/25 border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-12 flex items-center justify-center gap-2 text-sm text-background-50/60">
            <i className="ri-check-line text-accent-400"></i>
            <span>无需信用卡</span>
            <span className="mx-2">·</span>
            <i className="ri-check-line text-accent-400"></i>
            <span>永久免费</span>
            <span className="mx-2">·</span>
            <i className="ri-check-line text-accent-400"></i>
            <span>3分钟上手</span>
          </div>
        </div>
      </div>
    </section>
  );
}